import React, { useState } from "react";
import "../Style/Component/Reviewcard.css";
// import profile from "../Assets/Splash/reviewimage.png";
import sendarrow from "../Assets/Splash/send.svg";
import star from "../Assets/Splash/greystar.svg";
import yellowstar from "../Assets/Splash/yellowstar.svg";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { postWithTokenAPI, putWithTokenAPI } from "../Util/Api.js";
import logo from "../Assets/Splash/admin.jpg";

const Reviewcard = ({ review, onReplySuccess }) => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const permission = auth.permission;
  // const review={
  //     image:'',
  //     name:'Nithya',
  //     city:'Tirunelveli',
  //     scrap:'Plastic',
  //     Review:5,
  //     date:'26 Nov 2025',
  //     content:'Very convenient app! Booking a scrap pickup was easy and the collection was on time. The staff was polite and professional.',

  // }
  const [reply, setReply] = useState("");

  function formatToIndianDate(isoDate) {
    if (!isoDate) return "";

    const date = new Date(isoDate);

    const day = date.getDate();
    const month = date.toLocaleString("en-IN", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  const handleSendReply = async () => {
    if (!reply.trim()) {
      toast.error("Reply cannot be empty");
      return;
    }

    try {
      const payload = {
        reply_comment: reply,
        replied_by: "admin",
      };

      const response = await putWithTokenAPI(
        token,
        `/feedback/update/${review?.feedback_id}`,
        payload,
      );

      if (response?.status === 200 || response?.statusCode === 200) {
        toast.success("Reply sent successfully");
        setReply("");
        onReplySuccess?.();
      } else {
        toast.error("Failed to send reply");
      }
    } catch (error) {
      console.error("Reply error", error);
      toast.error("Something went wrong");
    }
  };
  return (
    <div className="reviewcard">
      <div className="reviewercontent">
        {review?.user_image ? (
          <img src={review?.user_image} alt="userprofile"></img>
        ) : (
          <div
            className="chat-avatar-fallback"
            style={{ width: "80px", height: "80px" }}
          >
            {review?.user_name?.[0].toUpperCase()}
            {review?.user_name?.slice(-1).toUpperCase()}
          </div>
        )}
        <span>
          <span className="name">{review?.user_name}</span>
          <span style={{ color: "green" }}>{review?.user_city}</span>
          {/* <span>Scrap:{review?.scrapName}</span> */}
        </span>
      </div>
      <div className="reviewcontent">
        <div className="dateintext">
          <div
            className="ratingg"
            style={{
              width: "60%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            {[...Array(5)].map((_, index) => (
              <img
                key={index}
                src={index < review?.rating ? yellowstar : star}
                alt="star"
                className="star-icon"
              />
            ))}
            <span style={{ marginLeft: "7px" }}>
              {formatToIndianDate(review?.createdAt)}
            </span>
          </div>
        </div>
        <span>{review?.comments}</span>
        {review?.reply_comment && permission?.splash_screen?.create ? (
          <div className="adminreply">
            <img src={logo} className="adpp"></img>
            <div>
              <span>
                <span className="adminrep">Admin</span>
                {review?.reply_comment}
              </span>
            </div>
            {/* <span>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nobis inventore odio voluptatem temporibus corrupti. Esse ratione atque tempore animi, aliquid qui sit mollitia quisquam ab officia consequatur quod natus quasi unde. Iste unde et maxime dignissimos eligendi saepe placeat architecto qui commodi asperiores vel vero, deserunt natus! Illum, recusandae dignissimos repellendus molestias reiciendis magnam ut quam deleniti, earum doloribus quae! Quis, dolore aliquid nisi obcaecati provident nam tempore laudantium, in perspiciatis, iste labore? Expedita modi provident doloribus inventore. Ex, amet? Cumque consectetur itaque voluptates, nesciunt illum voluptas harum et eaque at. Libero laudantium deleniti, dolores perferendis similique cumque impedit et!</span> */}
          </div>
        ) : (
          permission?.splash_screen?.create && (
            <div className="replyreview">
              <input
                type="text"
                placeholder="Reply"
                value={reply}
                onChange={(e) => setReply(e.target.value)}
              />
              <img src={sendarrow} onClick={() => handleSendReply()}></img>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Reviewcard;
